/**
 * Animation timing constants for the FlashCard components
 * Centralizing these values makes it easier to maintain consistent animations
 * across all related components.
 */
export const ANIMATION_TIMINGS = {
    // Card flip animation
    FLIP_DURATION: 500,          // Time for card flip animation (ms)
    
    // Feedback animations
    EXCELLENT_DISPLAY: 800,      // How long to show "Excellent!" feedback (ms)
    
    // Card movement animations
    SWIPE_DURATION: 250,         // Time for swipe animation (ms) - reduced from 350ms for faster movement
    CARD_RISE: 700,              // Duration of card rise animation (ms)
    DECK_ANIMATION: 600,         // Time for deck/stack animation (ms)
    
    // Transition buffers and delays
    ENTRANCE_DELAY: 250,         // Delay before entrance animation (ms)
    STATE_TRANSITION_BUFFER: 50, // Buffer time between state transitions (ms)
    SWIPE_CALLBACK_DELAY: 50     // Delay before calling swipe callbacks (ms)
  };